import { saveAs } from "file-saver";
import { Paperclip, X } from "lucide-react";
import React, { MouseEvent } from "react";

import { SerializedBuffer } from "@winshop-crm/types";

type InputProps = {
  fileName: string;
  /** Either a base64 string or a `Buffer` as it arrives over JSON. */
  file: string | SerializedBuffer;
  onDelete?: () => void;
};

export const WSFile = ({ fileName, file, onDelete }: InputProps) => {
  const handleFileDownload = (fileName: string, file: string | SerializedBuffer) => {
    const buffer = typeof file === "string" ? Buffer.from(file, "base64") : Buffer.from(file.data);
    const blob = new Blob([buffer]);
    // downloadBlob(blob, fileName);
    saveAs(blob, fileName);
  };

  const handleDelete = (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <div className="relative inline-flex items-center px-3 py-1 my-1 text-sm border rounded-full bg-neutral-background border-primary-backgroundSubtle">
      <button
        type="button"
        className="inline-flex items-center cursor-pointer"
        onClick={() => handleFileDownload(fileName, file)}
      >
        <Paperclip className="w-3 h-3 mr-1" />
        <span className="text-xs text-neutral-text">{fileName}</span>
      </button>
      {onDelete && (
        <button
          type="button"
          onClick={(e) => handleDelete(e)}
          className="p-1 ml-2 -mr-2 rounded-full text-danger-action bg-neutral-backgroundSubtle focus:outline-hidden hover:bg-danger-actionHover"
        >
          <X className="w-2 h-2" />
        </button>
      )}
    </div>
  );
};

export default WSFile;
